import React from "react";
import HPButton from "../common/Button";
import { ModalProps } from "../../_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface ClearAvailabilityDateModalProps extends ModalProps {
  action: () => void;
}

const ClearAvailabilityDateModal: React.FC<
  ClearAvailabilityDateModalProps
> = ({ action, closeAction, cancelAction }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  const handleCancel = cancelAction || closeAction || closeTopModal;

  return (
    <div className="bg-white w-full rounded-lg shadow-lg flex flex-col max-w-fit mx-auto min-w-[540px]">
      <div className="p-6 flex gap-1">
        <h2 className="text-lg font-semibold">Clear Available Through?</h2>
      </div>

      <div className="text-sm border-t border-b border-hp-border-default">
        <div className="p-6 flex flex-col gap-2">
          <p>
            Clearing Available Through will disable Latest Available Data in
            chart configuration and dynamic charts will temporarily use the
            latest date with data until Available Through is set again.
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-1 p-4">
        <HPButton
          ariaLabel="Cancel"
          variant="text"
          size="medium"
          color="primary"
          onClick={handleCancel}
          className="text-hp-text-day-primary"
        >
          Cancel
        </HPButton>

        <HPButton
          ariaLabel="Clear and save"
          variant="outlined"
          size="medium"
          onClick={action}
          color="error"
        >
          Clear and Save
        </HPButton>
      </div>
    </div>
  );
};

export default ClearAvailabilityDateModal;
